import {Title} from './styles/ic-tools.styled'

interface QuartermasterWebProps {
    smallSize?: boolean
}
export function QuartermasterWeb({smallSize = false}: QuartermasterWebProps): JSX.Element {
    return <Title smallSize={smallSize}>Quartermaster</Title>
}
